"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _LeftOutlined = _interopRequireDefault(require("@ant-design/icons/LeftOutlined"));

var _color = _interopRequireDefault(require("color"));

var _Currency = _interopRequireDefault(require("@meepshop/context/lib/Currency"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _locales = require("@meepshop/locales");

var _filter = _interopRequireDefault(require("@meepshop/utils/lib/filter"));

var _Empty = _interopRequireDefault(require("./Empty"));

var _Products = _interopRequireDefault(require("./Products"));

var _Price = _interopRequireDefault(require("./Price"));

var _useComputedCart = _interopRequireDefault(require("./hooks/useComputedCart"));

var _useComputedCart2 = require("./gqls/useComputedCart");

var _products = require("./gqls/products");

var _price = require("./gqls/price");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
require("./styles/index.less");

var styles = {
  "screenSmMax": "767px",
  "root": "store-cart-previewer__previewer-index__root",
  "title": "store-cart-previewer__previewer-index__title",
  "products": "store-cart-previewer__previewer-index__products",
  "footer": "store-cart-previewer__previewer-index__footer",
  "button": "store-cart-previewer__previewer-index__button"
}; // graphql typescript

// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var viewer = _ref.viewer,
      onClose = _ref.onClose;

  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  var _useContext2 = (0, _react.useContext)(_Currency["default"]),
      c = _useContext2.c;

  var _useTranslation = (0, _locales.useTranslation)('cart-previewer'),
      t = _useTranslation.t;

  var computedCart = (0, _useComputedCart["default"])((0, _filter["default"])(_useComputedCart2.useComputedCartInPreviewerFragment, viewer));
  var productsRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      scrolled = _useState2[0],
      setScrolled = _useState2[1];

  var totalPrice = (computedCart === null || computedCart === void 0 ? void 0 : computedCart.totalPrice) || 0;
  var productTotal = (0, _react.useMemo)(function () {
    return ((computedCart === null || computedCart === void 0 ? void 0 : computedCart.computedLineItems) || []).reduce(function (total, _ref2) {
      var quantity = _ref2.quantity,
          unitPrice = _ref2.unitPrice;
      return total + (quantity || 0) * (unitPrice || 0);
    }, 0);
  }, [computedCart]);
  (0, _react.useEffect)(function () {
    var productsNode = productsRef.current;

    var onScroll = function onScroll() {
      if (((productsNode === null || productsNode === void 0 ? void 0 : productsNode.scrollTop) || 0) > 0) setScrolled(true);else setScrolled(false);
    };

    if (productsNode) {
      productsNode.addEventListener('scroll', onScroll);
    }

    return function () {
      if (productsNode) productsNode.removeEventListener('scroll', onScroll);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.title
  }, /*#__PURE__*/_react["default"].createElement(_LeftOutlined["default"], {
    onClick: onClose
  }), t('cart')), !(computedCart !== null && computedCart !== void 0 && computedCart.computedLineItems.length) ? /*#__PURE__*/_react["default"].createElement(_Empty["default"], {
    onClose: onClose
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.products,
    ref: productsRef
  }, /*#__PURE__*/_react["default"].createElement(_Products["default"], {
    viewer: (0, _filter["default"])(_products.productsInPreviewerUserFragment, viewer),
    products: (0, _filter["default"])(_products.productsInPreviewerLineItemFragment, computedCart.computedLineItems)
  }), /*#__PURE__*/_react["default"].createElement(_Price["default"], {
    computedCart: (0, _filter["default"])(_price.priceInPreviewerFragment, computedCart),
    productTotal: productTotal
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, t('total')), /*#__PURE__*/_react["default"].createElement("span", null, c(totalPrice))), /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: "/cart"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.button
  }, t('go-to-cart')))))), /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n            .".concat(styles.root, " {\n              color: ").concat(colors[3], ";\n              background-color: ").concat(colors[0], ";\n              box-shadow: 0 2px 15px -3px ").concat((0, _color["default"])(colors[3]).alpha(0.65), ";\n            }\n\n            .").concat(styles.footer, " {\n              border-top-color: ").concat((0, _color["default"])(colors[5]).alpha(0.5), ";\n            }\n\n            .").concat(styles.button, " {\n              color: ").concat(colors[6], ";\n              background-color: ").concat(colors[4], ";\n              box-shadow: 0 1px 5px 0 ").concat((0, _color["default"])(colors[2]).alpha(0.2), ";\n            }\n\n            ").concat(!scrolled ? '' : "\n              @media (max-width: ".concat(styles.screenSmMax, ") {\n                .").concat(styles.footer, " {\n                  box-shadow: 0 -2px 6px 0 ").concat((0, _color["default"])(colors[3]).alpha(0.1), ";\n                }\n              }\n            "), "\n          ")
    }
  }));
});

exports["default"] = _default;